import TcVod from "vod-js-sdk-v6";

async function uploadVideo(videoFile, sign) {
  return uploadVideoWithProcess(videoFile, sign, null);
}

async function uploadVideoWithProcess(videoFile, sign, onProgress) {
  const tcVod = new TcVod({
    getSignature: () => sign.data,
  });

  const uploader = tcVod.upload({
    enableResume: true, // 断点续传
    dynamicAccelerate: true, // 开启动态加速
    mediaFile: videoFile,
  });

  uploader.on("media_progress", (info) => {
    const percent = Math.floor(info.percent * 10000) / 100;
    const speed = Math.floor((info.speed / 1024 / 1024) * 100) / 100;
    console.log(`进度：${percent}%; 速度：${speed}Mb/s;`);
    if (typeof onProgress === "function") {
      onProgress(percent, speed, uploader);
    }
  });
  const result = await uploader.done();
  console.log(result.video.url, ' 上传完成');
  return {
    url: result.video.url,
    fileId: result.fileId,
  };
}

// 本地出现Vod上传跨域： 可调用Mock方法测试交互效果
async function uploadVideoWithProcessForLocal(_videoFile, _sign, onProgress) {
  const loop = 3;
  for (let index = 1; index <= loop; index++) {
    await sleep(1000);
    const percent = Math.floor(100 / loop) * index;
    const speed = Math.floor(100) / 100;
    console.log(`进度：${percent}%; 速度：${speed}Mb/s;`);
    if (typeof onProgress === "function") {
      onProgress(percent, speed);
    }
  }
  await sleep(1000);
  return {
    url: "http://www.local.com/test.mp4",
    fileId: 123546,
  };
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  uploadVideo,
  uploadVideoWithProcess,
  uploadVideoWithProcessForLocal,
};
